import { getOrgIdByUser } from "@/utils/gaoding";
import { gdSlsReportError } from "@/utils/gdSlsRum";
import { isSpiderClient } from "@/utils/isSpider";
import Cookies from "js-cookie";
import { abTestInit } from "./abTest";
import AutoTrigger from "./autoTrigger";
import collectInit from "./collecter";
import pvTracker from "./report/pvTracker";
import { TrackerEvent } from "./shared/event";
import getPageData from "./shared/getPageData";
import { BEFORE_PAGE_CHANGE, PAGE_CHANGED } from "./shared/variable";

export const autoTrigger = new AutoTrigger();
export let GDTrackerInitPromise = null;
export let TrackerInitFailed = false;

let gdTracker = null;
const version = "2.0.0";

export const GD_CHANNEL_ID = "32";
export const HB_CHANNEL_ID = "289";
/**
 * 埋点初始化：无垠埋点、百度统计
 * @param {{ isMobile: boolean; user: IUser; }} param0
 */
export default function initTracker({ isMobile, user }) {
  // 服务端情况、没有稿定脚本下不执行
  if (typeof window === "undefined" || !window.gdTracker || isSpiderClient()) {
    return;
  }

  // 客户端避免执行多次
  if (GDTrackerInitPromise) return;
  // storybook情况下不执行
  if (typeof isstorybook === "boolean") return;

  GDTrackerInitPromise = new Promise(async (resolve) => {
    try {
      // SDK 埋点初始化
      // gdTracker = await import("@gaoding/gd-tracker");
      gdTracker = window.gdTracker;

      initTrackerSdk(gdTracker, { isMobile });

      setTrackerUser(user);
      // 设置用户信息后，再进行pv初始化与上报
      pagevistInit();

      // 自动埋点初始化
      collectInit(autoTrigger);

      if (!window._hmt) {
        window._hmt = [];
      }
      window._hmt.push(["_setUserProperty", { version: version }]);
      resolve();
    } catch (error) {
      error.message = "gd tracker init failed. " + error.message;
      console.error(error);
      TrackerInitFailed = true;
      gdSlsReportError(error);
      resolve();
    }
  });
}
// 不自动上报的页面
const disableAutoReporter = ["采集详情页", "画板详情页"];
function initTrackerSdk(gdTracker, { isMobile }) {
  const { tracker } = gdTracker;
  const ENV_MAP = {
    "pinban.com": "dev",
    "local.huaban.com": "dev",
    "dev.huaban.com": "dev",
    "fat.huaban.com": "fat",
    "huaban.com": "prod",
    "stage.huaban.com": "stage",
    "www.huaban.com": "prod",
  };

  const showLog = window.location.search.indexOf("__tracker_log=1") >= 0;
  const debugMode = window.location.search.indexOf("__tracker_debug=1") >= 0;
  const env = ENV_MAP[window.location.host] || "dev";
  const isProd = window.location.host.indexOf("huban.com") >= 0;
  const version = isMobile ? "H5_2.0.0" : "2.0.0";
  const isGD = window.location.search.indexOf("from=gd") >= 0;

  const trackerOptions = {
    wind: {
      project: "hb_web",
      version: version,
      env: env,
      showLog: showLog,
      transport: "xhr",
      fdidEnable: true,
      plugins: [
        ["utm-data-tracker"],
        ["page-duration-tracker", { eventId: 39022 }], // 页面浏览时长插件，没配置 eventId 时默认上报 eventId = 39022
      ],
      channel: {
        // 渠道信息
        channel_id: isGD ? GD_CHANNEL_ID : HB_CHANNEL_ID, // [可选] (字符串): 渠道 ID
      },
    },
    // 百度统计
    // _hmt: {
    //   projectId: "d4a0e7c3cd16eb58a65472f40e7ee543",
    // },
  };

  tracker.setup(trackerOptions, isProd, debugMode);
}

function pagevistInit() {
  historyWrap();

  TrackerEvent.on(PAGE_CHANGED, () => {
    pageVisitReporter();
  });

  pageVisitReporter();

  function pageVisitReporter() {
    const page = getPageData();
    if (!disableAutoReporter.includes(page?.page_nm)) {
      pvTracker(page, {
        bd_disabled: true,
      });
    }
  }
}

/**
 * 用户信息改变时触发
 * @param {IUser} user
 * @returns
 */
export function setTrackerUser(user) {
  // 未初始化不执行
  if (!gdTracker) return;

  const { trackerWind, ABTestDataTracker } = gdTracker;

  const vipLevel = user?.extra?.material_vip || null;

  trackerWind.set("common", {
    is_login: user ? 1 : 0,
    user_id: user
      ? user.user_id + ""
      : trackerWind.get("common", "device_id").device_id,
    vip_level: vipLevel === -1 ? 0 : vipLevel,
  });

  if (user) {
    const gd_id = Cookies.get("gd_id");

    trackerWind.set("event", {
      uuic_id: user.extra?.gd_id || gd_id,
    });

    trackerWind.set("common", {
      organization: {
        org_id: user.extra.org_id,
        uc_id: user.uc_id,
        product_type: user.extra.org_type,
      },
    });
  } else {
    trackerWind.set("event", {
      uuic_id: null,
    });

    trackerWind.set("common", {
      organization: {
        org_id: "",
        uc_id: "",
        product_type: "",
      },
    });
  }

  const abtest = abTestInit({
    is_login: user ? 1 : 0,
    user_id: user
      ? user.user_id + ""
      : trackerWind.get("common", "device_id").device_id,
    device_id: trackerWind.get("common", "device_id").device_id,
    org_id: getOrgIdByUser(user) || "0",
  });

  trackerWind.use("ABTestDataTracker", ABTestDataTracker, { abtest });
}

// 重写history方法，用于监听页面变化
function historyWrap() {
  // 重写history方法
  // go back forward方法会触发popstate事件，为了避免重复触发，所以不需要重写
  // 而且 go back forward方法不能通过location获取到变化的url
  const fnMap = ["pushState", "replaceState"];

  // 存在  popstate事件 和 window.history 方法都触发的情况，所以需要加一个状态避免触发两次
  let popstateEventFlag = false;

  fnMap.forEach((fn) => {
    try {
      const oldFn = "old" + fn;

      if (window.history[oldFn]) return;

      window.history[oldFn] = window.history[fn];
      window.history[fn] = function (...args) {
        try {
          TrackerEvent.trigger(BEFORE_PAGE_CHANGE, window.location);

          window.history[oldFn](...args);

          TrackerEvent.trigger(PAGE_CHANGED, window.location);

          // 标识popstate事件触发
          popstateEventFlag = true;
          setTimeout(() => {
            // 重置状态
            popstateEventFlag = false;
          }, 0);
        } catch (error) {
          error.message = "页面切换埋点相关报错: " + error.message;
          console.error(error);
        }
      };
    } catch (error) {}
  });

  // 存在刷新前进回退不触发 history api的
  window.addEventListener("popstate", function (e) {
    if (popstateEventFlag) {
      popstateEventFlag = false;
      return;
    }

    TrackerEvent.trigger(BEFORE_PAGE_CHANGE, window.location);
    TrackerEvent.trigger(PAGE_CHANGED, window.location);
  });
}
